import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Container, Grid, List, Message } from "semantic-ui-react";
import {
  cartItemsSelector,
  cartSelector,
  cartTotalPriceSelector,
  orderSelector,
  paymentMethodSelector,
} from "../../utils/selectors";
import CheckoutProgress from "../../components/CheckoutProgress";
import {
  Body1,
  Body2,
  Heading3,
  Heading5,
} from "../../components/value-cssmodules/TextComponent";
import { CartData } from "../../types/siteTypes";
import isEmpty from "../../validation/is-empty";
import styles from "./PlaceOrder.module.scss";
import OrderItem from "./OrderItem";
import { FiShoppingCart } from "react-icons/fi";
import OrderCard from "./OrderCard";
import { createOrder } from "../../actions/orderActions";

const PlaceOrder = () => {
  const navigate = useNavigate();
  const cart = useSelector((s) => cartSelector(s));
  const cartLength = useSelector((s) => cartItemsSelector(s));
  const totalPrice = useSelector((s) => cartTotalPriceSelector(s));
  const orderCreate = useSelector((s) => orderSelector(s));
  const paymentMethod = useSelector((state: any) =>
    paymentMethodSelector(state.payment)
  );
  const [searchParams] = useSearchParams();
  const paramsMethod = searchParams.get("paymentMethod");
  const {code } = useSelector((state: any) => state.promo);

  const dispatch = useDispatch();
  const { order, success, error } = orderCreate;

  useEffect(() => {
    if (success) {
      navigate(`/order/${order._id}`);
    }
    // eslint-disable-next-line
  }, [success, navigate]);

  const placeOrder = () => {
    dispatch(
      createOrder({
        orderItems: cart,
        paymentMethod: paymentMethod || paramsMethod,
        totalPrice,
     
      }, code)
    );
  };

  return (
    <Container>
      <Grid centered>
        <Grid.Column computer={10} mobile={16}>
          <CheckoutProgress active={"checkout"} />
          <Grid.Row>
            <Heading3>
              <FormattedMessage
                id="placeOrder.title"
                defaultMessage="Place order"
              />
            </Heading3>
            <Body1>
              <FormattedMessage
                id="placeOrder.paymentMethod.title"
                defaultMessage="Payment method"
              />
            </Body1>
            <Body2>
              <FormattedMessage
                id="placeOrder.paymentMethod.value"
                defaultMessage="Method: {method}"
                values={{ method: paymentMethod || paramsMethod }}
              />
            </Body2>
          </Grid.Row>
          {isEmpty(cart) ? (
            <Heading5>
              <FormattedMessage
                id="placeOrder.cartEmpty"
                defaultMessage="Your cart is empty"
              />
              <FiShoppingCart className={styles.cart} />
            </Heading5>
          ) : (
            <Grid.Row className={styles.row}>
              <Heading5>
                <FormattedMessage
                  id="placeOrder.order.title"
                  defaultMessage="Order"
                />
              </Heading5>
              <List divided relaxed>
                {cart.map((item: CartData) => {
                  return (
                    <OrderItem
                      key={`orderlist-${item.id}-${item.selectedSize || ""}`}
                      item={item}
                    />
                  );
                })}
              </List>
            </Grid.Row>
          )}
        </Grid.Column>
        {error ? (
          <Message warning> {error} </Message>
        ) : (
          <Grid.Column computer={6} mobile={16}>
            <OrderCard cartLength={cartLength} order={placeOrder} />
          </Grid.Column>
        )}
      </Grid>
    </Container>
  );
};

export default PlaceOrder;
